import { LoaderManagerService } from '@anecdotes/design-system/loaders';
import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { TrustCenterFacadeService } from '@anecdotes/shared-trust-center';

@Component({
  selector: 'app-trust-center-page-layout',
  templateUrl: './trust-center-page-layout.component.html',
})
export class TrustCenterPageLayoutComponent implements OnInit, OnDestroy {
  @HostBinding('class')
  private readonly classes = 'flex h-full w-full bg-navy-20';

  constructor(
    // Having LoaderManagerService provided but not used is crucial, as child components relies on this one!
    private readonly loaderManager: LoaderManagerService,
    private readonly trustCenterFacade: TrustCenterFacadeService,
  ) {}

  ngOnInit(): void {
    this.loaderManager.hide();
  }

  ngOnDestroy(): void {
    this.trustCenterFacade.clearEvidenceCache();
  }
}
